import React from 'react';
export const About = () => {
  return <section id="about" className="py-16 bg-stone-100" data-id="element-9">
      <div className="container mx-auto px-4" data-id="element-10">
        <div className="max-w-3xl mx-auto" data-id="element-11">
          <h2 className="text-3xl font-light text-stone-800 mb-2 inline-block border-b-2 border-red-700 pb-1" data-id="element-12">
            About Me
          </h2>
          <p className="text-sm text-stone-500 mb-8" data-id="element-13">自我介绍</p>
          <div className="prose prose-stone lg:prose-lg max-w-none" data-id="element-14">
            <p data-id="element-15">江西抚州人, 95 年生人，身高一米八二。</p>
            <p data-id="element-16">一个不务正业的程序员</p>
            <p data-id="element-17"></p>
            <div className="mt-8 flex flex-col sm:flex-row sm:items-center" data-id="element-18">
              <div className="text-lg font-medium text-stone-800 sm:mr-4" data-id="element-19">
                座右铭:
              </div>
              <div className="mt-2 sm:mt-0 px-4 py-2 bg-indigo-900/10 border-l-4 border-indigo-900 text-stone-700 italic" data-id="element-20">
                "纸上得来终觉浅 得知此事要躬行"
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};